import Modal from "react-bootstrap/Modal";
import { styleEnd, styleStart } from "../../algorithms/styleDirection";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import moment from "moment";
import "moment/locale/ar";
import { useEffect } from "react";
import { paths } from "../../paths/paths";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";

const AttachmentsPopup = (props) => {
  const { onHide, name, content, isActivity, subProcId } = props;
  useEffect(() => {
    if (Lang.getLanguage() === "ar") moment.locale("ar");
    else moment.locale("en");
  }, []);

  const getPath = (attachment) => {
    if (subProcId) {
      return `${paths.SubTaskProcedureAttachments}${subProcId}/${attachment?.id}/${attachment.attachment}`;
    }
    console.log(attachment);
  };

  if (content?.length > 0) {
    return (
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        {...props}
        style={{ zIndex: 1000000 }}
        backdrop="static"
      >
        <Modal.Header
          style={{ direction: getDir(getCurrentLangFromRedux()) }}
          className="d-flex align-items-start"
        >
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="d-flex align-items-center">
              <div
                className="mx-2 d-flex justify-content-center align-items-center"
                style={{
                  height: 32,
                  width: 32,
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="16.188"
                  viewBox="0 0 16 12.188"
                >
                  <path
                    id="folder_1_"
                    data-name="folder (1)"
                    d="M15.869,67.188a1.092,1.092,0,0,0-.963-.575H12.813v-2.5a1.251,1.251,0,0,0-1.25-1.25H5.938v-.625a1.251,1.251,0,0,0-1.25-1.25H1.25A1.251,1.251,0,0,0,0,62.237V72.706H0a.468.468,0,0,0,.469.469H12.344a.469.469,0,0,0,.391-.21l3.084-4.657A1.092,1.092,0,0,0,15.869,67.188ZM1.25,61.925H4.688A.313.313,0,0,1,5,62.237v1.094a.469.469,0,0,0,.469.469h6.094a.313.313,0,0,1,.313.313v2.5h-.938V65.206a.469.469,0,0,0-.469-.469H2.344a.469.469,0,0,0-.469.469V69.57l-.938,1.5V62.237a.313.313,0,0,1,.313-.313Zm2.732,4.688a.469.469,0,0,0-.4.22l-.772,1.236V65.675H10v.938Zm11.055,1.179-2.944,4.446H1.314l1.412-2.261a.466.466,0,0,0,.031-.049L4.242,67.55H14.906a.156.156,0,0,1,.131.242Z"
                    transform="translate(0 -60.987)"
                    fill="#12aac4"
                  />
                </svg>
              </div>
              <div className="text-dark">
                <p
                  className="my-0 mx-2"
                  style={{ fontSize: 18, textAlign: "justify" }}
                >
                  {name}
                </p>
              </div>
            </div>
          </Modal.Title>
          <div
            className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}
          >
            <Icon
              name="times"
              size={22}
              color={"#1A73E8"}
              onclick={() => {
                onHide();
              }}
            />
          </div>
        </Modal.Header>
        <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          {content.map((item, index) => {
            return (
              <div
                key={index + parseInt(item.id)}
                className="d-flex mx-4 my-3"
                style={{
                  backgroundColor: "rgb(242, 242, 242)",
                  borderRadius: "10px 10px 0 0",
                }}
              >
                <div className="d-flex justify-content-start col-10 align-items-center py-3">
                  {isActivity == false ? (
                    <a
                      href={`${
                        item.taskProcedureId
                          ? paths.TaskProcedureAttachments
                          : paths.TasksAttachments
                      }${item.taskProcedureId ?? item.taskId ?? 0}/${item.id}/${
                        item.attachment
                      }`}
                      className={`d-flex text-decoration-none ${styleStart(
                        "m",
                        2
                      )}`}
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <div className="mx-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16.049 15.568"
                        >
                          <path
                            id="ic_attachment_24px"
                            d="M0,3.972A3.97,3.97,0,0,1,3.972,0h7.583a2.889,2.889,0,1,1,0,5.777H5.416a1.805,1.805,0,1,1,0-3.611h5.416V3.611H5.351c-.4,0-.4.722,0,.722h6.2a1.444,1.444,0,1,0,0-2.889H3.972a2.528,2.528,0,1,0,0,5.055h6.861V7.944H3.972A3.97,3.97,0,0,1,0,3.972Z"
                            transform="translate(0 9.664) rotate(-42)"
                            fill="#12aac4"
                          />
                        </svg>
                      </div>

                      <div>
                        {/* filename here */}
                        <p className="m-0 text-dark">{item.attachment}</p>
                      </div>
                    </a>
                  ) : (
                    <a
                      href={getPath(item)}
                      className={`d-flex text-decoration-none ${styleStart(
                        "m",
                        2
                      )}`}
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <div className="mx-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16.049 15.568"
                        >
                          <path
                            id="ic_attachment_24px"
                            d="M0,3.972A3.97,3.97,0,0,1,3.972,0h7.583a2.889,2.889,0,1,1,0,5.777H5.416a1.805,1.805,0,1,1,0-3.611h5.416V3.611H5.351c-.4,0-.4.722,0,.722h6.2a1.444,1.444,0,1,0,0-2.889H3.972a2.528,2.528,0,1,0,0,5.055h6.861V7.944H3.972A3.97,3.97,0,0,1,0,3.972Z"
                            transform="translate(0 9.664) rotate(-42)"
                            fill="#12aac4"
                          />
                        </svg>
                      </div>

                      <div>
                        {/* filename here */}
                        <p className="m-0 text-dark">{item.attachment}</p>
                      </div>
                    </a>
                  )}
                </div>

                <div className="d-flex col-2 align-items-center justify-content-end">
                  {isActivity == false ? (
                    <a
                      download
                      href={`${
                        item.taskProcedureId
                          ? paths.TaskProcedureAttachments
                          : paths.TasksAttachments
                      }${item.taskProcedureId ?? item.taskId ?? 0}/${item.id}/${
                        item.attachment
                      }`}
                      className={`${styleEnd("m", 4)}`}
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="16"
                        viewBox="0 0 14 17"
                      >
                        <path
                          id="ic_file_download_24px"
                          d="M19,9H15V3H9V9H5l7,7ZM5,18v2H19V18Z"
                          transform="translate(-5 -3)"
                          fill="#12aac4"
                        />
                      </svg>
                    </a>
                  ) : (
                    <a
                      download
                      href={getPath(item)}
                      className={`${styleEnd("m", 4)}`}
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="16"
                        viewBox="0 0 14 17"
                      >
                        <path
                          id="ic_file_download_24px"
                          d="M19,9H15V3H9V9H5l7,7ZM5,18v2H19V18Z"
                          transform="translate(-5 -3)"
                          fill="#12aac4"
                        />
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </Modal.Body>
      </Modal>
    );
  } else
    return (
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        {...props}
        style={{ zIndex: 1000000 }}
        backdrop="static"
      >
        <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="d-flex align-items-center">
              <div
                className="mx-2 d-flex justify-content-center align-items-center"
                style={{
                  height: 32,
                  width: 32,
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="16.188"
                  viewBox="0 0 16 12.188"
                >
                  <path
                    id="folder_1_"
                    data-name="folder (1)"
                    d="M15.869,67.188a1.092,1.092,0,0,0-.963-.575H12.813v-2.5a1.251,1.251,0,0,0-1.25-1.25H5.938v-.625a1.251,1.251,0,0,0-1.25-1.25H1.25A1.251,1.251,0,0,0,0,62.237V72.706H0a.468.468,0,0,0,.469.469H12.344a.469.469,0,0,0,.391-.21l3.084-4.657A1.092,1.092,0,0,0,15.869,67.188ZM1.25,61.925H4.688A.313.313,0,0,1,5,62.237v1.094a.469.469,0,0,0,.469.469h6.094a.313.313,0,0,1,.313.313v2.5h-.938V65.206a.469.469,0,0,0-.469-.469H2.344a.469.469,0,0,0-.469.469V69.57l-.938,1.5V62.237a.313.313,0,0,1,.313-.313Zm2.732,4.688a.469.469,0,0,0-.4.22l-.772,1.236V65.675H10v.938Zm11.055,1.179-2.944,4.446H1.314l1.412-2.261a.466.466,0,0,0,.031-.049L4.242,67.55H14.906a.156.156,0,0,1,.131.242Z"
                    transform="translate(0 -60.987)"
                    fill="#12aac4"
                  />
                </svg>
              </div>
              <div className="text-dark">
                <p
                  className="my-0 mx-2"
                  style={{ fontSize: 18, textAlign: "justify" }}
                >
                  {name}
                </p>
              </div>
            </div>
          </Modal.Title>
          <div
            className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}
          >
            <Icon
              name="times"
              size={22}
              color={"#1A73E8"}
              onclick={() => {
                onHide();
              }}
            />
          </div>
        </Modal.Header>
        <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <div className="d-flex flex-lg-row flex-column justify-content-center align-items-center me-xl-4 mx-lg-4 me-4">
            <div>{Lang.noAttachments}</div>
          </div>
        </Modal.Body>
      </Modal>
    );
};

export default AttachmentsPopup;
